import * as z from "zod";

import { type Workspace } from "@/domain/workspace/models/workspace-model";

export const FocusAreaSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  color: z.string(),
  order: z.string().nullable().optional(),
  icon: z.string().nullable().optional(),
  iconType: z.string().nullable().optional(),
});

export type FocusArea = z.infer<typeof FocusAreaSchema>;

export const FocusAreaInstanceSchema = z.object({
  id: z.string(),
  focusAreaId: z.string(),
  ownerId: z.string(),
  ownerType: z.string(),
  focusArea: FocusAreaSchema,
});

export type FocusAreaInstance = z.infer<typeof FocusAreaInstanceSchema>;

export type DashboardFocusAreaRow = {
  workspace: Workspace;
  focusArea: FocusArea;
};

export const DEFAULT_FOCUS_AREA_COLOR = "#95999F";

export const DEFAULT_FOCUS_AREA: FocusArea = {
  id: "",
  workspaceId: "",
  name: "",
  color: DEFAULT_FOCUS_AREA_COLOR,
  icon: null,
  iconType: null,
};

export const NO_FOCUS_AREA_ID = "no-focus-area";

export const createEmptyFocusArea = (name: string): FocusArea => ({
  id: NO_FOCUS_AREA_ID,
  name,
  workspaceId: "-1",
  color: DEFAULT_FOCUS_AREA_COLOR,
});
